import { TAB_QUERY_PARAM } from 'src/pages/UserCircle/Tabs/tabByLabel';

export type CalendarStep = {
  id: string;
  title: string;
  text: string;
  context: string;
};

type SectionLike = {
  proposed_actions?: Array<{ title?: string; first_step?: string }>;
  next_step?: string;
};

export function collectCalendarSteps(
  boxIds: string[],
  results: Record<string, SectionLike | undefined>,
  labelFor: (boxId: string) => { context: string; fieldLabel: string }
): CalendarStep[] {
  const steps: CalendarStep[] = [];

  for (const boxId of boxIds) {
    const section = results[boxId];
    if (!section) {
      continue;
    }
    const labels = labelFor(boxId);
    const actions = Array.isArray(section.proposed_actions)
      ? section.proposed_actions
      : [];

    actions.forEach((action, index) => {
      const text = action.first_step?.trim() ?? '';
      if (!text) {
        return;
      }
      steps.push({
        id: `${boxId}:first:${index}`,
        title: action.title?.trim() || 'Første steg',
        text,
        context: labels.context,
      });
    });

    const nextStep = section.next_step?.trim() ?? '';
    if (nextStep) {
      steps.push({
        id: `${boxId}:next`,
        title: `Neste steg – ${labels.fieldLabel}`,
        text: nextStep,
        context: labels.context,
      });
    }
  }

  return steps;
}

/**
 * The address a calendar event links back to: the Utviklingsplan tab of the
 * circle the step was added from, or the standalone page outside a circle.
 */
export function developmentPlanUrl(circleId?: string): string {
  const origin = window.location.origin;
  if (!circleId) {
    return `${origin}/oth/utviklingsplan`;
  }
  return `${origin}/circle/${encodeURIComponent(circleId)}?${TAB_QUERY_PARAM}=Utviklingsplan`;
}
